import React from 'react';

const Ru = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_46_48)">
        <path d="M16 0H0V8H16V0Z" fill="white" />
        <path d="M16 8H0V16H16V8Z" fill="#D52B1E" />
        <path d="M16 5.33337H0V10.6667H16V5.33337Z" fill="#0039A6" />
      </g>
      <defs>
        <clipPath id="clip0_46_48">
          <rect width="16" height="16" rx="3" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default Ru;
